import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { Column } from 'seagull';
import { outputToCost } from '~/components/ServiceBuilder/ServiceBuilder.utils';
import ServicePriceEditorPopoverBundleContent from '~/components/ServicePriceEditorPopover/ServicePriceEditorPopoverBundleContent/ServicePriceEditorPopoverBundleContent';
import ServicePriceEditorPopoverPricingContent from '~/components/ServicePriceEditorPopover/ServicePriceEditorPopoverPricingContent/ServicePriceEditorPopoverPricingContent';
import { serviceModel } from '~/models';
import { inputBillingDataToModel } from '~/models/service-billing/setters';
function getEffectiveTrigger(data) {
    const { pricing, trigger } = data;
    const isVariablePricing = pricing === 'hour' || pricing === 'unit' || pricing === 'range';
    if (isVariablePricing && trigger === 'ongoing') {
        return 'manualVariable';
    }
    return trigger;
}
export const ServiceRateModalContent = (param)=>{
    let { service, draft, setDraft } = param;
    const { watch } = useFormContext();
    useEffect(()=>{
        const subscription = watch((formValues)=>{
            const data = formValues;
            const cost = outputToCost({
                output: data,
                originalService: service
            });
            const effectiveTrigger = getEffectiveTrigger(data);
            const billing = inputBillingDataToModel({
                billingForm: _object_spread_props(_object_spread({}, data), {
                    trigger: effectiveTrigger
                }),
                originalService: service
            });
            setDraft(draft.setService(service.id, (s)=>{
                let updated = serviceModel.setCost(s, cost);
                updated = serviceModel.setBillingTrigger(updated, billing);
                return updated;
            }));
        });
        return ()=>subscription.unsubscribe();
    }, [
        service,
        draft,
        setDraft
    ]);
    return /*#__PURE__*/ _jsxs(Column, {
        children: [
            /*#__PURE__*/ _jsx(ServicePriceEditorPopoverPricingContent, {
                serviceOrigin: "draft"
            }),
            /*#__PURE__*/ _jsx(ServicePriceEditorPopoverBundleContent, {})
        ]
    });
};
